import LegalPageLayout from '@/components/feature/LegalPageLayout';

export default function TermsPage() {
  return (
    <LegalPageLayout title="Kullanım Şartları">
      <h4>1. Genel Hükümler</h4>
      <p>Bu web sitesini ziyaret ederek ve kullanarak aşağıdaki kullanım şartlarını kabul etmiş sayılırsınız. Atak Sistem Enerji, bu şartları önceden haber vermeksizin değiştirme hakkını saklı tutar.</p>

      <h4>2. Fikri Mülkiyet Hakları</h4>
      <p>Bu web sitesinde yer alan tüm içerik, tasarım, logo, görsel, metin ve diğer materyaller Atak Sistem Enerji'ye ait olup, izinsiz kullanımı, kopyalanması veya dağıtılması yasaktır.</p>

      <h4>3. Site Kullanımı</h4>
      <p>Web sitemizi yalnızca yasal amaçlarla kullanabilirsiniz. Site üzerinden yasa dışı, tehdit edici, taciz edici veya başka şekilde uygunsuz içerik paylaşamazsınız.</p>

      <h4>4. Sorumluluk Reddi</h4>
      <p>Web sitesinde yer alan bilgiler genel bilgilendirme amaçlıdır. Atak Sistem Enerji, site içeriğinin doğruluğu, güncelliği veya eksiksizliği konusunda garanti vermez. Sitedeki bilgilere dayanarak yapılan işlemlerden doğabilecek zararlardan sorumlu tutulamaz.</p>

      <h4>5. Üçüncü Taraf Bağlantıları</h4>
      <p>Web sitemiz, üçüncü taraf web sitelerine bağlantılar içerebilir. Bu sitelerin içeriğinden veya gizlilik uygulamalarından sorumlu değiliz.</p>

      <h4>6. Bağlantılı Hizmetler</h4>
      <p>WhatsApp, Instagram ve Google Maps gibi üçüncü taraf platformlara yönlendiren bağlantılarımız bulunmaktadır. Bu platformların kendi kullanım şartları geçerlidir.</p>

      <h4>7. İletişim</h4>
      <p>Kullanım şartlarımız hakkında sorularınız için WhatsApp veya 0266 246 41 59 numaralı telefondan bize ulaşabilirsiniz.</p>
    </LegalPageLayout>
  );
}